import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'
import { useServiceTemplatesStore } from "@/stores/serviceTemplates";
import { useEstablishmentStore } from "@/stores/establishment";

const Names = {
  fr: 'iframe-exemple',
  en: 'iframe-example'
}

const Config: TrPageConfigInterface = {
  name: Names.fr,
  path: `/${Names.fr}`,
  alias: `/${Names.en}`,
  meta: {
    title: {
      fr: 'IFrame exemple',
      en: 'IFrame example'
    },
    description: {
      fr: '',
      en: ''
    }
  },
  props: (route) => ({ query: route.query }),
  component: () => import('@page/iframeExample/IframeExample.vue'),
  beforeEnter: async (to, from, next) => {
    const serviceTemplatesStore = useServiceTemplatesStore()
    const establishmentStore = useEstablishmentStore()

    await serviceTemplatesStore.fetchServiceTemplatesSEO()
    await establishmentStore.fetchAllAvailableEstablishments()

    next()
  }
}

export { Config }
